import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { ScannerBrandInfo } from '../fragments';

export default gql`
  mutation createScannerBrand($input: ScannerBrandCreateInput!) {
    createScannerBrand(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      scannerBrand {
        ...ScannerBrandInfo
      }
    }
  }
  ${ScannerBrandInfo}
  ${ErrorMessageInfo}
`;
